import styled from 'styled-components'

import ButtonLink from '@/common/components/ButtonLink'

export const SeeDetailsButton = styled(ButtonLink).attrs({
  className: 'mx-auto',
  buttonClassName: 'text-12 text-nowrap px-12',
  variant: 'outline',
})`
  > button {
    height: 24px;
  }
`
